<template>
  <div
    class="min-h-screen bg-style"
    :style="{ backgroundImage: `url(${backgroundImageURL})` }"
  ></div>
</template>
<script>
export default {
  components: {},
  computed: {
    activeAuthImage () {
      return process.env.VUE_APP_TENANT_NAME
    },
    backgroundImageURL () {
      const imageMapping = {
        oval: require('@/assets/images/oval-auth-password.svg'),
        torus: require('@/assets/images/torus-auth-password.svg'),
        tma: require('@/assets/images/tma-auth-image.svg')
      }

      return imageMapping[this.activeAuthImage] || ''
    }
  }
}
</script>

<style>
.bg-style {
  background-size: cover;
}
</style>
